import { createAction } from 'redux-actions';

import {SURFACE_MAP_ADD, ACTIVE_SURFACE_MAP_SET} from './constants';


const surfaceMapAddAction = createAction(SURFACE_MAP_ADD);
const activeSurfaceMapSetAction = createAction(ACTIVE_SURFACE_MAP_SET);

export const surfaceMapAddRedux = (payload) => async (dispatch) => dispatch(surfaceMapAddAction(payload));
export const activeSurfaceMapSetRedux = (payload) => async (dispatch) => dispatch(activeSurfaceMapSetAction(payload));